require('ignite-root/js/modules/infragistics.util.js');
require('ignite-root/js/modules/infragistics.util.jquery.js');
require('ignite-root/js/modules/infragistics.ui.widget.js');
require('ignite-root/js/modules/infragistics.datasource.js');
require('ignite-root/js/modules/infragistics.templating.js');
require('ignite-root/js/modules/infragistics.ext_core.js');
require('ignite-root/js/modules/infragistics.ext_collections.js');
require('ignite-root/js/modules/infragistics.ext_ui.js');
require('ignite-root/js/modules/infragistics.dv_jquerydom.js');
require('ignite-root/js/modules/infragistics.dv_core.js');
require('ignite-root/js/modules/infragistics.dv_geometry.js');
require('ignite-root/js/modules/infragistics.dv_interactivity.js');
require('ignite-root/js/modules/infragistics.dv_visualdata.js');
require('ignite-root/js/modules/infragistics.datachart_core.js');
require('ignite-root/js/modules/infragistics.dvcommonwidget.js');
require('ignite-root/js/modules/infragistics.ui.chart.js');
require('ignite-root/js/modules/infragistics.datachart_categorycore.js');
require('ignite-root/js/modules/infragistics.datachart_category.js');
require('ignite-root/js/modules/infragistics.datachart_rangecategory.js');
require('ignite-root/js/modules/infragistics.datachart_verticalcategory.js');
require('ignite-root/js/modules/infragistics.datachart_annotation.js');
require('ignite-root/js/modules/infragistics.datachart_interactivity.js');
require('ignite-root/js/modules/infragistics.legend.js');
require('ignite-root/js/modules/infragistics.ui.chartlegend.js');
require('ignite-root/js/modules/infragistics.piechart.js');
require('ignite-root/js/modules/infragistics.ui.chart.js');
// ISeriesInteractionManager
